import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DatatableComponent, SelectionType } from "@swimlane/ngx-datatable";
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { CatalogDetFacade } from '../../../common/facade/CatalogDetFacade';
import { DeviceFacade } from '../../../common/facade/DeviceFacade';
import { StoreFacade } from "../../../common/facade/StoreFacade";
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { Permissions } from '../../../common/model/dictionary/Permissions';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { Router } from '@angular/router';

@Component({
  selector: 'app-device-admin',
  templateUrl: './device-admin.component.html',
  styleUrls: ['./device-admin.component.css']
})
export class DeviceAdminComponent implements OnInit {
  titleManageDevicesAbbr = res.ManageDevicesAbbr;
  lblDownload = res.Download;
  lblEdit = res.Edit;
  lblAdd = res.Add;
  lblDeviceType = res.DeviceType;
  lblSearch = res.Search;
  lblSerialCode = res.SerialCode;
  lblIdentifier = res.Identifier;
  lblModel = res.Model;
  lblStatus = res.Status;
  lblComments = res.Comments;
  lblAssignedStore = res.AssignedStore;
  lblCurrentStore = res.CurrentStore;
  lblLastOnlineEvent = res.LastOnlineEvent;
  lblAPKVersion = res.APKVersion;
  lblUnassigned = res.Unassigned;
  lblSelectAnOption = res.SelectAnOption;
  lblSave = res.Save;
  lblClose = res.Close;

  isSpanish = true;
  language = 0

  messagesTable : any = {
    emptyMessage: "",
    totalMessage: "" 
  }

  // Properties and Attributes *******************************
  //permissions
  permissionsList: any[] = []

  lsDeviceStatus: any[] = []
  lsDeviceType: any[] = []
  lsStore: any[] = []

  //table
  @ViewChild('tableDevice') tableDevice: DatatableComponent;
  @ViewChild('modal') public modal: ModalDirective;
  rows: any[] = []
  _filteredData = []
  selected : any[] = []
  SelectionType = SelectionType

  device = {
    deviceId: 0,
    serialCode: "",
    identifier: "",
    catDetDeviceTypeId: 0,
    catDetStatusId: 0,
    comment: "",
    model: "",
    assignedStoreId: 0
  }

  loading = false
  messageLoader = ''
  currentDate = Date

  //alert
  alerts: any[] = [];
  alertModal: any[] = [];

  deviceId =0

  // HTML elements
  lblModalTittle: string = ""
  txtSerialCode: string = ""
  txtIdentifier: string = ""
  txtModel: string =""
  cmb_DeviceType: number = -1
  cmb_deviceStatus: number = -1
  txtComment: string = ""
  cmb_Store: number = -100
  btnEditModal: boolean = false
  deviceTypeFilter = 2551;
  //Button Flags
  visibleAdd = false
  visibleEdit = false
  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    @Inject('BASE_URL') baseUrl: string,
    private _facadeDevice: DeviceFacade,
    private _facadeCatDet: CatalogDetFacade,
    private _facadeStore: StoreFacade,
    private _excel: ExcelUtility,
    public strings: Strings,
    private _router: Router
  ) {
    this._storage.set('moduleUrl', this._router.url);
   }

  ngOnInit() {
    this.loading = true
    this.messageLoader = this.strings.GetText(res.GettingDeviceList);

    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    if (!this.isSpanish) {
      this.language = 1
    }

    // get DeviceType
    this._facadeCatDet.Get(11, this.language).subscribe(result => 
      {
        if(result.completed)
        {
          this.lsDeviceType = result.data
        }
    }, error => 
    {
      this.loading = false
      this.addAlert('<strong>'+error+'</strong>','danger')
      return
    });

    // get DeviceStatus
    this._facadeCatDet.Get(29, this.language).subscribe(result => 
      {
        if(result.completed)
        {
          this.lsDeviceStatus = result.data
        }
    }, error => 
    {
      this.loading = false
      this.addAlert('<strong>'+error+'</strong>','danger')
      return
    });

    // get Store
    this._facadeStore.GetParticipateQuantum().subscribe(result => 
      {
        if(result.completed)
        {
          this.lsStore = result.data
        }
    }, error => 
    {
      this.loading = false
      this.addAlert('<strong>'+error+'</strong>','danger')
      return
    });

    this.onTypeChange()
    this.validatePermissions()
  }


  onTypeChange()
  {
    this.loading = true
    this._facadeDevice.GetAll(this.deviceTypeFilter, this.language).subscribe(result => 
      {
        if(result.completed)
        {
          this.rows = result.data
          this._filteredData = result.data;
        }
        this.loading = false
      }, error => 
      {
        this.loading = false
        this.addAlert('<strong>'+error+'</strong>','danger')
        return
      });
  }
  
  openModal(create:boolean)
  {
    this.alertModal = [];
    if (create)
    {
      this.btnEditModal = false
      this.lblModalTittle = this.strings.GetText(res.AddDevice);
      this.deviceId = 0
      this.txtSerialCode = ""
      this.txtIdentifier = ""
      this.txtModel = ""
      this.cmb_DeviceType = -1
      this.cmb_deviceStatus = -1
      this.txtComment = ""
      this.cmb_Store = -100

      this.modal.show()
    }
    else
    {
      if (this.validateRow())
      {
        this.btnEditModal = true
        this.lblModalTittle = this.strings.GetText(res.EditDevice);

        this.deviceId = this.selected[0].deviceId
        this.txtSerialCode = this.selected[0].serialCode
        this.txtIdentifier = this.selected[0].identifier
        this.cmb_DeviceType = this.selected[0].catDetDeviceTypeId
        this.cmb_deviceStatus = this.selected[0].catDetStatusId
        this.txtComment = this.selected[0].comment
        this.cmb_Store = this.selected[0].storeId

        this.modal.show()
      }
    }    
  }

  validateRow() : Boolean
  {
    if (this.selected.length == 0)
    {
      this.addAlert("<strong>" + this.strings.GetText(res.SelectARecordToEdit) + "</strong>","warning")
      return false
    }
    else
      return true
  }

  saveDevice()
  {
    if (this.validateModalInfo())
    {
      this.loading = true;
      this._facadeDevice.Create(this.device).subscribe(result => 
        {
          if(result.completed)
          {
            if (result.data <= 0)
            {
              this.addAlertModal('<strong>'+result.message+'</strong>','danger')
            }
            else
            {
              this.modal.hide()
              this.onTypeChange()
              this.addAlert('<strong>' + this.strings.GetText(res.DeviceRegisteredSuccessfully) + '</strong>','success')
            }
          }
          else
          {
            this.addAlertModal('<strong>'+result.message+'</strong>','danger')
          }
          this.loading = false;
      }, error => 
      {
        this.addAlert('<strong>'+error+'</strong>','danger')
        this.loading = false;
        this.modal.hide()
      });
    }
  }

  editDevice()
  {
    if (this.validateModalInfo())
    {
      this.loading = true;
      this._facadeDevice.Update(this.device).subscribe(result => 
        {
          if(result.completed)
          {
            if (result.data <= 0)
            {
              this.addAlertModal('<strong>'+result.message+'</strong>','danger')
            }
            else
            {
              this.modal.hide()
              this.onTypeChange()
              this.addAlert('<strong>' + this.strings.GetText(res.DeviceEditedSuccessfully) + '</strong>','success')
            }
          }
          else
          {
            this.addAlertModal('<strong>'+result.message+'</strong>','danger')
          }
          this.loading = false;
      }, error => 
      {
        this.addAlert('<strong>'+error+'</strong>','danger')
        this.loading = false;
        this.modal.hide()
      });
    }
  }

  validateModalInfo() : boolean
  {
    if (this.txtSerialCode == '' || this.txtIdentifier == '' || this.txtModel == '' || 
        this.cmb_DeviceType == -1 || this.cmb_deviceStatus == -1 || this.cmb_Store == -100)
    {
      this.addAlertModal('<strong>' + this.strings.GetText(res.FillInAllTheFieldsMarked) + ' *</strong>','warning')
      return false
    }

    if (this.cmb_deviceStatus == 56) //Asignado
    {
      if (this.cmb_Store == -100 || this.cmb_Store == -1)
      {
        this.addAlertModal('<strong>' + this.strings.GetText(res.SelectStoreToWhichTheDeviceAssigned) + '</strong>','warning')
        return false
      }
    }
    
    this.device.deviceId = this.deviceId
    this.device.serialCode = this.txtSerialCode,
    this.device.identifier = this.txtIdentifier,
    this.device.catDetDeviceTypeId = this.cmb_DeviceType,
    this.device.catDetStatusId = this.cmb_deviceStatus,
    this.device.comment = this.txtComment,
    this.device.model = this.txtModel,
    this.device.assignedStoreId = this.cmb_Store
    
    return true
  }

  // añadir alert
  addAlert(message: String, type: String): void {
    this.alerts.push({
      type: type,
      msg: message,
      timeout: 5000
    });
  }

  // añadir alert
  addAlertModal(message: String, type: String): void {
    this.alertModal.push({
      type: type,
      msg: message,
      timeout: 5000
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent)
  {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
    this.alertModal = this.alertModal.filter(alert => alert !== dismissedAlert);
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    let val = event.target.value.toLowerCase();
    // get the amount of columns in the table
    let colsAmt = 20;

    // get the key names of each column in the dataset
    let keys = Object.keys(this._filteredData[0]);

    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
        // iterate through each row's column data
        for (let i = 0; i < keys.length; i++) {

            if (item[keys[i]] != null &&
                (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) 
            {
                return true;
            }
        }
    });

    this.tableDevice.offset = 0;
  }

  downloadLayout() {
    if (this.rows.length > 0) {
        const data: any = [];
        this.rows.forEach(row => {
            const info = {
                [this.strings.GetText(res.SerialCode)] : row.serialCode,
                [this.strings.GetText(res.Identifier)] : row.identifier,
                [this.strings.GetText(res.DeviceType)] : row.deviceType,
                [this.strings.GetText(res.Model)] : row.model,
                [this.strings.GetText(res.Status)] :  row.status,
                [this.strings.GetText(res.Comments)] : row.comment,
                [this.strings.GetText(res.AssignedStore)] : (row.assignedStoreId !== -1) ? row.assignedStoreId : 'Sin Asignar',
                [this.strings.GetText(res.CurrentStore)] : row.currentStoreId,
                [this.strings.GetText(res.LastOnlineEvent)] : row.lastEventDateFormat,
                [this.strings.GetText(res.APKVersion)] : row.apkVersion
            };
            data.push(info);
        });
        this._excel.exportAsExcelFile(data, 'data');
    } else {
        this.addAlert(this.strings.GetText(res.ThereIsNoInformation), 'danger');
    }
  }

  validatePermissions()
  {
    this.permissionsList = this._storage.get('permissions')
      this.permissionsList.forEach(element => {
          if (element.name == Permissions.GeneralAccess || element.name == Permissions.AdminDevicesCreate)
      {
        this.visibleAdd = true;
      }
    });

      this.permissionsList.forEach(element => {
          if (element.name == Permissions.GeneralAccess || element.name == Permissions.AdminDevicesEdit)
      {
        this.visibleEdit = true;
      }
    });
  }

}
